import {apiV2StableCoinAccountList} from "../../../../api/merchant/stablecoin";

const React = require('react');
import changeProviderProvider from 'mn-utils/changeProviderProvider';
import handleProviderProvider from 'mn-utils/changeProviderProviderSimple';
import {
  LINK_BANK_ACCOUNT_CREATE,
  LINK_DASHBOARD,
  LINK_WITHDRAWAL,
} from '../../../../constants/links';
import {
  backLocation,
  Link,
  pushLocation,
} from '../../../../router';
import formatNumCurrency from '../../../../utils/formatNumCurrency';
import numberHandle from '../../../../utils/numberHandle';
import withState from '../../../../utils/withState';
import {
  apiV2AssetsAmountLimits,
  apiV2AssetsAmountList,
} from '../../../../api/merchant/assetsAmount';
const trim = require('mn-utils/trim');
const filter = require('mn-utils/filter');
const find = require('mn-utils/find');
const upperFirst = require('mn-utils/upperFirst');
const {
  DEFAULT_CURRENCY,
} = require('../../../../constants');
const {
  apiV2WithdrawCreate,
} = require('../../../../api/merchant/withdraw');
const {
  apiV2BankList,
} = require('../../../../api/merchant/bank');
const {
  openPopupInfo,
} = require('../../../../emitters/popup');
const WrapperWithLoading = require('../../../dumb/WrapperWithLoading/B');
const Caption = require('../../../dumb/Caption/C');
const Select = require('../../../dumb/Select/H');
const Ripple = require('../../../dumb/Ripple');
const ButtonM = require('../../../dumb/Button/Decline');
const ButtonN = require('../../../dumb/Button/Accept');
const Field = require('../../../dumb/Field/E');
import ButtonBack from '../../../dumb/Button/BackB';
import {apiV2WithdrawCryptoCoinCreate, apiV2WithdrawFiatCreate} from "../../../../api/merchant/withdraw";
import {account$, getUserMainPage} from "../../../../emitters/account";
import {MerchantInput, MerchantSelect} from "../../../helpers/InputsHelpers";
import ReportDownload from "../../../dumb/ReportDownload/B";
import {MerchantPageHeader} from "../../../helpers/Display";
const TextField = require('../../../dumb/TextField/A');
const {WITHDRAW_MIN_AMOUNT, WITHDRAW_MIN_AMOUNT_USD} = require('../../../../constants/withdrawalLimits');

// const WITHDRAW_MIN_AMOUNT = 5;
const DESCRIPTION_MAX_LENGTH = 15000;


function propNameBank(v) {
  const type = v.primary ? 'primary' : 'secondary';
  return (
    <div className="w layoutRow fhaB fvaC f12 lts0em c0 wmax300">
      <div
        className="fw7 fx1 wmin0 ws tov ov pr10"
      >{v.name || v.iban || v.address}</div>
      {!v.isSingleAccount
        ? (
          <div
            className={`fw3 tr c2CE889.primary cFFBF43.secondary ` + type}
          >{upperFirst(type)}</div>
        ) : false
      }
    </div>
  );
}


module.exports = withState((setState, self, onMount) => {
  const changeProvider = changeProviderProvider(setState);
  const handleProvider = handleProviderProvider(setState);

  const handleChangeDescription = changeProvider('description');
  const handleChangeAmount = changeProvider('amount', 0, numberHandle);
  const handleChangeBankAccountId = handleProvider('bankAccountId');


  self.state = {
    loading: true,
    assetAccountsList: [],
    assetAmount: {},
    clicked: false,
    amount: '',
    description: '',
    isStableCoin: false
  };

  onMount(async () => {
    const {type, assetCode} = (self.props.params || {});

    if (!type || !assetCode) {
      pushLocation({
        path: getUserMainPage(),
      })
    }

    const withdrawMinAmount = assetCode === 'USD' ? WITHDRAW_MIN_AMOUNT_USD : WITHDRAW_MIN_AMOUNT;

    const isStableCoin = type === 'stablecoin';

    const assetAccountKey = isStableCoin ? 'asset_code' : 'fiat_code';
    const assetAmountKey = isStableCoin ? 'sc_code' : 'fiat_code';
    const assetAccountsListRequest = isStableCoin ? apiV2StableCoinAccountList : apiV2BankList;

    const assetAccountsList = await assetAccountsListRequest({limit: 1000}).then((res) => {
      const list = res.list || [];
      const filteredList = list.filter((el) => el[assetAccountKey] === assetCode);
      return filteredList.map((el) => ({...el, isSingleAccount: filteredList.length === 1}));
    });

    const assetLimit = isStableCoin
      ? 500
      : await apiV2AssetsAmountLimits({
        fiat_codes: [assetCode],
        min_amount: 500
      }).then((res) => res[assetCode] || withdrawMinAmount);

    const assetAmount = await apiV2AssetsAmountList({limit: 1000}).then((res) => {
      const list = res.list || [];
      return list.find((el) => el[assetAmountKey] === assetCode);
    });

    if (Number((assetAmount || {}).available) < Number(assetLimit)) {
      pushLocation({
        path: getUserMainPage(),
      });
      return;
    }

    setState({
      loading: false,
      isStableCoin,
      assetLimit,
      assetAccountsList,
      bankAccountId: assetAccountsList.length ? assetAccountsList[0].id : false,
      assetAmount
    });
  });

  const backToDashboardPage = () => {
    const accountDefaultFiat = (account$.getValue() || {}).fiat;
    const assetCode = (self.props.params || {}).assetCode || DEFAULT_CURRENCY;
    const params = accountDefaultFiat !== assetCode ? `?assetCode=${assetCode}` : '';

    pushLocation({
      path: getUserMainPage() + params,
    });
  }

  return (state, props) => {
    const params = props.params || {};
    const assetCode = params.assetCode || DEFAULT_CURRENCY;
    const asset = state.assetAmount || {};
    const assetLimit = state.assetLimit || {};
    const amountTotal = asset.total || 0;
    const amountAvailable = parseFloat(asset.available || 0);
    const {
      bankAccountId,
      description,
      clicked,
      isStableCoin
    } = state;



    const amountNumber = asset.available;
    const banksOfAsset = state.assetAccountsList || [];

    const invalidBankAccountId = !bankAccountId;
    const invalidAmountEmpty = !asset.available;
    const invalidAmountMin = WITHDRAW_MIN_AMOUNT > amountNumber || !amountNumber;
    const invalidAmountMax = amountAvailable < amountNumber;
    const invalidAmount = invalidAmountEmpty || invalidAmountMin || invalidAmountMax;

    const invalidDescription = description.length > DESCRIPTION_MAX_LENGTH;

    const disabled = invalidBankAccountId || invalidAmount || invalidDescription;

    return (
      <div className={props.className}>
        <MerchantPageHeader
          title="Manual withdraw"
          backFN={backToDashboardPage}
        />
        <WrapperWithLoading
          className="fx1 wmin0"
          loading={state.loading}
        >
          <div className="rlv">
            {!banksOfAsset.length && (
              <div className="w100%+20 h100%+20 layoutRow fxdC jcC aiC abs st-10 sl-10 bgF0.3 z10" style={{backdropFilter: 'blur(3px)'}}>
                <div className="tc lh24">
                  {isStableCoin ? 'Stablecoin' : 'Bank'} accounts list for this {isStableCoin ? 'coin' : 'currency'} is empty.<br/>
                  Please add at least one to proceed with withdrawal process.
                </div>
                <Ripple
                  component={Link}
                  className="layoutRow fvaC fhaC h45 wmin75 mt20 ph20 bs b1 bcC r9 ttU olN
                    f12 fw4 tdN ov dn bc0:h ml20"
                  href={LINK_BANK_ACCOUNT_CREATE}
                  options={{
                    query: {
                      assetCode,
                      type: isStableCoin ? 'stablecoinAccounts' : 'bankAccounts'
                    },
                  }}
                >Add new account +</Ripple>
              </div>
            )}
            <div className="mt20 cfx mh-25 (lt|ph25|w1/2|w@m)>1">
              <div>
                <div className="mb30 layoutRow fhaS fvaC">
                  <div className="rlv fx1 wmin0">
                    <MerchantInput
                      label="Amount"
                      name="amount"
                      value={asset.available}
                      disabled
                    />
                    {/*<TextField*/}
                    {/*  className="pr52>.ph22"*/}
                    {/*  label="Amount"*/}
                    {/*  value={asset.available}*/}
                    {/*  disabled*/}
                    {/*  // onChange={handleChangeAmount}*/}
                    {/*  // error={clicked && invalidAmount}*/}
                    {/*  helperText={(<div className="wmin400">*/}
                    {/*    {*/}
                    {/*      invalidAmountEmpty*/}
                    {/*        ? `Obligatory field`*/}
                    {/*        : (*/}
                    {/*          invalidAmountMax*/}
                    {/*            ? `The amount cannot exceed the available balance of ${amountAvailable} ${assetCode}`*/}
                    {/*            : `*Minimum withdrawal limit is ${WITHDRAW_MIN_AMOUNT} EUR or similar in the local currency`*/}
                    {/*        )*/}
                    {/*    }*/}
                    {/*  </div>)}*/}
                    {/*/>*/}
                    {/*<div className="h100%-26 abs st0 sr0 z5 mt26 f11 fw5">*/}
                    {/*  <Ripple className="w66 h layoutRow jcC aiC bg5B47FF bg4B37EF:h rrt9 rrb9 cF" onClick={() => {*/}
                    {/*    handleChangeAmount({target: {value: String(amountAvailable)}})*/}
                    {/*  }}>*/}
                    {/*    MAX*/}
                    {/*  </Ripple>*/}
                    {/*</div>*/}
                  </div>
                  <Field
                    className="ml20"
                    label={isStableCoin ? 'Stablecoin' : 'Currency'}
                  >
                    <div
                      className="layoutRow fvaC fhaC h45 wmin120 bs b1 bc0 r6
                      ttU olN f12 fw4 tdN ov mt15"
                    >{assetCode}</div>
                  </Field>
                </div>
                <Field label={isStableCoin ? 'Stablecoin account' : 'Bank account'}>
                  <div className="layoutRow fhaS fvaC">
                    <MerchantSelect
                      propName={propNameBank}
                      propValue="id"
                      displayEmpty
                      items={banksOfAsset}
                      value={bankAccountId}
                      onChange={handleChangeBankAccountId}
                      error={clicked && invalidBankAccountId}
                      disabled={!banksOfAsset.length || banksOfAsset.length === 1}
                    />
                    <Ripple
                      component={Link}
                      className="layoutRow fvaC fhaC h45 wmin120 bs b1 bc0 r6 ttU olN
                      f12 fw4 tdN ov dn bc0:h ml20"
                      href={LINK_BANK_ACCOUNT_CREATE}
                      options={{
                        query: {
                          assetCode,
                          type: isStableCoin ? 'stablecoinAccounts' : 'bankAccounts'
                        },
                      }}
                    >Add +</Ripple>
                  </div>
                </Field>
              </div>
              <div>
                <div className="hmin150 bgF6F6F6 layoutRow fhaC fvaC ov ph25 r9 mt27">
                  <div className="cfx w (lt|pv10|wmin0|w1/2)>1">
                    <Field label="Actual balance">
                      <div className="f23 fw4 lh lts0em ws ov tov mt-5">
                        {formatNumCurrency(amountTotal)} {assetCode}
                      </div>
                    </Field>
                    <Field label="Available balance">
                      <div className="f23 fw7 lh lts0em ws ov tov mt-5">
                        {formatNumCurrency(amountAvailable)} {assetCode}
                      </div>
                    </Field>
                  </div>
                </div>
              </div>
              <div>
                <TextField
                  className="mt27 hmin132>textarea"
                  label="Reference"
                  value={description}
                  error={invalidDescription}
                  onChange={handleChangeDescription}
                  helperText={invalidDescription
                    ? <div className="mt8">Field length exceeds maximum</div>
                    : ''
                  }
                  multiline
                />
                <div className='layoutRow jcFE mt10'>
                  <span className={'cF00.error' + (invalidDescription ? ' error' : '')}>
                    {description.length} / {DESCRIPTION_MAX_LENGTH}
                  </span>
                </div>
              </div>
            </div>
            <div className="mt17 cfx mh-28 (lt|ph28|pb20)>1">
              <div>
                <ButtonN
                  disabled={clicked && disabled}
                  onClick={() => {
                    if (disabled) {
                      setState({
                        clicked: true,
                      });
                      return;
                    }

                    const withdrawCreateRequest = isStableCoin
                      ? apiV2WithdrawCryptoCoinCreate
                      : apiV2WithdrawFiatCreate;

                    const params = {
                      amount: asset.available,
                      description: trim(description),
                    };

                    const bankIdParamKey = isStableCoin
                      ? 'stablecoin_id'
                      : 'bank_id';

                    params[bankIdParamKey] = bankAccountId;

                    withdrawCreateRequest(params).finally((error, response) => {
                      if (error) {
                        setState({
                          loading: false,
                        });
                        return;
                      }
                      /*
                      setState({
                        loading: false,
                        clicked: false,
                        amount: '',
                        description: '',
                      });
                      */

                      backToDashboardPage();

                      // const id = response && response.id;
                      // const type = isStableCoin ? 'stablecoin' : 'fiat';

                      // if (id) {
                      //   pushLocation({
                      //     path: `${LINK_WITHDRAWAL}/${type}/${id}`
                      //   });
                      //   return;
                      // } else {
                      //   const accountDefaultFiat = (account$.getValue() || {}).fiat;
                      //   const params = accountDefaultFiat !== assetCode ? `?assetCode=${assetCode}` : '';
                      //
                      //   pushLocation({
                      //     path: getUserMainPage() + params,
                      //   });
                      // }

                      openPopupInfo([
                        'Withdraw',
                        <>
                          Thank you for your request!<br/>
                          Your withdrawal request will be processed immediately.<br/>
                          The requested withdrawal amount will be deposited to your account within 2-3 business days.
                        </>,
                      ]);
                    });
                  }}
                >Withdraw</ButtonN>
              </div>
              <div>
                <ButtonM
                  onClick={backToDashboardPage}
                >Cancel</ButtonM>
              </div>
            </div>
          </div>
        </WrapperWithLoading>
      </div>
    );
  };
});
